import React, { useCallback, useRef } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import "./fileuploadStyles.scss";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useSnackbar } from "../../../hooks/useSnackbar";
import Loader from "../Loader/Loader";

const UploadFileComponent: React.FunctionComponent<any> = (props) => {
  const {
    acceptedMimeTypes,
    maxFileSize,
    selectedFileData,
    fileformats,
    setIsUploaded,
    file,
    setFile,
  } = props;
  const dropAreaRef = useRef<HTMLDivElement>(null);

  const { showError } = useSnackbar();

  const handleFile = useCallback((selectedFile: File) => {
    if (!acceptedMimeTypes.includes(selectedFile.type)) {
      showError(
        `Invalid file type. Please upload ${fileformats
          ?.slice(0, -1)
          .join(", ")} or ${fileformats[fileformats?.length - 1]} file`
      );
      return;
    }
    if (selectedFile.size > maxFileSize * 1024 * 1024) {
      showError(
        `File exceeds ${maxFileSize}MB limit. Please upload smaller file`
      );
      return;
    }
    setFile(selectedFile);
    setIsUploaded(true);
  }, []);

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    if (!file) {
      event.preventDefault();
      event.stopPropagation();
      const { files } = event.dataTransfer;
      if (files.length > 0) {
        handleFile(files[0]);
      }
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    if (!file) {
      event.preventDefault();
      event.stopPropagation();
      if (dropAreaRef.current) {
        dropAreaRef.current.style.borderColor = "#000";
      }
    }
  };

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    if (!file) {
      event.preventDefault();
      event.stopPropagation();
      if (dropAreaRef.current) {
        dropAreaRef.current.style.borderColor = "#ccc";
      }
    }
  };

  const handleFileInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { files } = event.target;
    if (files && files.length > 0) {
      handleFile(files[0]);
    }
  };
  return (
    <>
      <Loader />
      <form
        className="dropZoneBox"
        method="post"
        action=""
        encType="multipart/form-data"
      >
        <Box
          className="box__input"
          ref={dropAreaRef}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onClick={() => {
            if (!file || !selectedFileData?.filename) {
              const input = document.getElementById("fileInput");
              if (input) {
                input.click();
              }
            }
          }}
          sx={{
            cursor:
              file || selectedFileData?.filename ? "not-allowed" : "pointer",
            pointerEvents: file || selectedFileData?.filename ? "none" : "auto",
          }}
        >
          <Stack
            direction="column"
            spacing={1}
            justifyContent="center"
            alignItems="center"
          >
            {file || selectedFileData?.filename ? (
              <>
                <InsertDriveFileIcon
                  color="success"
                  sx={{ fontSize: "50px" }}
                />

                <Box className="textCenter textTruncate pt1">
                  {(file || selectedFileData.filename) && (
                    <small>{file?.name ?? selectedFileData?.filename}</small>
                  )}
                </Box>
              </>
            ) : (
              <CloudUploadIcon color="info" sx={{ fontSize: "50px" }} />
            )}
            <label
              htmlFor="file"
              style={{
                fontSize: "20px",
                fontWeight: 500,
                color: "rgba(0,0,0,0.6)",
              }}
            >
              {file || selectedFileData?.filename
                ? "Your file is attached"
                : `Drag and drop your file here or`}
            </label>
            {!(file || selectedFileData?.filename) && (
              <>
                <input
                  type="file"
                  id="fileInput"
                  hidden
                  onChange={handleFileInputChange}
                  disabled={!!file || selectedFileData?.filename}
                />
                <Button
                  variant="contained"
                  component="label"
                  className="primaryLiteBtn"
                  disabled={!!file || selectedFileData?.filename}
                >
                  Choose File
                </Button>
              </>
            )}
          </Stack>
        </Box>
      </form>
      <Stack
        direction="row"
        columnGap={2}
        justifyContent="space-between"
        className="mt1"
      >
        <Typography variant="caption">
          {` Allowed file formats are ${fileformats
            ?.slice(0, -1)
            .join(", ")} or ${fileformats[fileformats?.length - 1]}`}
        </Typography>
        <Typography variant="caption">{` Max file size ${maxFileSize} MB`}</Typography>
      </Stack>
    </>
  );
};

export default UploadFileComponent;
